/* eslint-disable @typescript-eslint/naming-convention */
export enum AestheticMedicineExperienceMT {
	"受けたことがあり、今後も継続したい",
	"受けたことがあるが、継続する意思はない",
	"受けたことがないが、興味はある",
	"受けたことがないし、興味もない",
}
